module.exports = __webpack_public_path__ + "sj.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/sj.svg
// module id = 803
// module chunks = 0